import { Home, Troubleshoot, Attachment, Save, Notes } from "@mui/icons-material";
import { Tabs } from "@mui/material";
import { matchPath } from "react-router";
import { SubHeaderProps } from "../../../../layout/MainLayout";
import { LinkTab } from "../../../../components/LinkTab";

export const NewTabs = (props: SubHeaderProps)  => {
    const routeMatch = matchPath(`/new/:tab?`, props.path)
    if (!routeMatch) {
        throw new Error("Unexpected");
    }
    const currentTab = routeMatch.params.tab ?? "";
    const rootPath = `/new/`;
    return <LogementTabs rootPath={rootPath} currentTab={currentTab} />
};

interface LogementTabsProps {
    readonly rootPath: string;
    readonly currentTab: string;
}

const LogementTabs = (props: LogementTabsProps) => {
    const { rootPath, currentTab } = props;
    return (
        <Tabs value={currentTab} variant="fullWidth" aria-label="Onglets">
            <LinkTab
                value=""
                rootPath={rootPath}
                icon={<Home />}
                aria-label="Logement" />
            <LinkTab
                value="diagnostic"
                rootPath={rootPath}
                icon={<Troubleshoot />}
                aria-label="Diagnostic" />
            <LinkTab
                value="comments"
                rootPath={rootPath}
                icon={<Notes />}
                aria-label="Commentaires" />
            <LinkTab
                value="documents"
                rootPath={rootPath}
                icon={<Attachment />}
                aria-label="Documents" />
            <LinkTab
                value="save"
                rootPath={rootPath}
                icon={<Save />}
                aria-label="Enregistrer" />
        </Tabs>);
}
